import { defineMessages } from 'react-intl';

export default defineMessages({
  inputDelete: {
    id: 'USER_LIST_ITEM.inputDelete',
    defaultMessage: 'Delete User',
  },
  inputEditUser: {
    id: 'USER_LIST_ITEM.inputEditUser',
    defaultMessage: 'Edit User',
  },
});



// WEBPACK FOOTER //
// ./components/molecules/UserListItem/messages.js